'use strict';

import angular from 'angular';
import ShowController from './show.controller';

export default angular.module('updateServerApp.betagroups.show', [])
  .controller('BetaGroupsShowController', ShowController)
  .name;



// WEBPACK FOOTER //
// ./client/app/betagroups/show/index.js